import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { pageTitle } from '@shared/brand'
import { App } from './App'
import { nativeApp } from './lib/native'
import { initAppearance } from './lib/theme'
import { watchVisualViewport } from './lib/visualViewport'
import { installNativeShell } from './shell/native'
import { registerServiceWorker } from './shell/pwa'
import { watchSessionFreshness } from './stores/session'
import './styles/theme.css'

// In der Merxo-App (iOS/Android-Hülle, docs/mobile/SPEZIFIKATION.md §4.5): Kennzeichnung vor dem ersten Rendern –
// CSS-Haken nur über html[data-app]
const app = nativeApp()
if (app) document.documentElement.dataset.app = app.platform
// Zurück-Taste (Android) und Bildschirmtastatur – nur in der App
installNativeShell()
// Sichtbarer Bereich als CSS-Variablen: Dialoge und Drawer bleiben bei offener Bildschirmtastatur ganz zu sehen
watchVisualViewport()

// Theme, Dichte und gemerkter Mandanten-Akzent; folgt danach den Systemeinstellungen
initAppearance()
document.title = pageTitle()

const root = document.getElementById('root')
if (!root) throw new Error('Das Element #root fehlt in index.html.')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// PWA: Service Worker für die Hülle (nur im gebauten Stand; API-Antworten werden nie zwischengespeichert).
// In der App keiner – dort räumt registerServiceWorker alte Worker weg und prüft selbst auf neue Fassungen.
registerServiceWorker()
// Funktionen, Rechte und Standorte, die in einem anderen Tab oder Gerät geändert wurden: beim Zurückkommen still nachladen
watchSessionFreshness()
